// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1d871e82","563":"96a253e7","791":"8d38413d"}[chunkId] + ".chunk.js";
};